import { render } from "./AzioniSottoProgetto.vue?vue&type=template&id=78f85d2a&ts=true"
import script from "./AzioniSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./AzioniSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__